import { BakeryEvent } from '../types/event'

// Halloween · vecka 44 · 26 okt – 1 nov 2026 (slutgiltigt schema)
export const events: BakeryEvent[] = [
  {
    id: 'halloween-start',
    title: 'Halloweenveckan drar igång!',
    date: '2026-10-26',
    description:
      'Vi tänder ljusen, pyntar vår servering och fyller diskarna med spökligt goda nyheter. Kom och känn Halloweenstämningen hos oss!',
    dropIn: true,
  },
  {
    id: 'halloween-run-club',
    title: 'Run Club & Pinsa AW',
    date: '2026-10-27',
    time: '18.00',
    description:
      'För vuxna som gillar rörelse, gemenskap och riktigt god mat! Vi springer tillsammans med Tuesday Run Club runt Växjösjön och avslutar med en härlig pinsabuffé på Top Notch. Löprundan startar från Top Notch på Klostergatan 7 och slutar även där.',
    highlight: {
      title: 'Run + AW + Pinsa · 159 kr/person',
      text: 'Spökigt goda pinsor, läskiga drinkar och lite skrämmande mysigt häng efter ett härligt tisdagsrun. I priset ingår löpning och pinsa efteråt. På plats finns en AW-dryckesmeny att ta del av (alkoholfritt finns också). Kom utklädd så får du 10 % rabatt! Betalning sker på plats i kassan – när du bokar godkänner du det.',
    },
    footnote:
      'Du är också välkommen på endast AW som drop in, men bokade platser går först. Priser på pinsa och dryck vid drop in är inte desamma som i paketet du bokar här.',
    bookingOptions: {
      question: 'Vad vill du vara med på?',
      choices: [
        {
          label: 'Löpning + AW & Pinsa',
          description: '159 kr/person – löpning och pinsa efteråt. AW-dryckesmeny finns på plats',
          note: 'Betalning sker på plats i kassan. Genom att boka godkänner du betalning på plats.',
        },
        {
          label: 'Endast löpning',
          description: 'Start och mål vid Top Notch, Klostergatan 7',
        },
      ],
    },
    signup: true,
  },
  {
    id: 'halloween-hidden-reality',
    title: 'Mordmysterier',
    date: '2026-10-28',
    time: '17.00',
    description:
      'En unik kväll där verklighet och fantasi möts. Boka in dig på en kväll med ett mordmysterium att lösa. Du kan boka ett helt spel för ditt eget sällskap. Du kan också välja ett öppet spel, där vi parar ihop er med ett annat gäng. Är ni få parar vi ihop er med fler, så att ni blir fler som löser mysteriet tillsammans.',
    highlight: {
      title: 'Anmälningsavgift 99 kr per anmälan',
      text: 'Samma pris oavsett hur många ni är och om ni väljer eget eller öppet spel. Avgiften gäller deltagandet i spelet – inget annat ingår. Vilket spel ni får bestäms på plats enligt principen först till kvarn. Mat och dryck köper ni till separat, till exempel några hela pinsor att dela på vid bordet.',
    },
    formNote:
      'Anmälningsavgiften är 99 kr per anmälan – oavsett antal personer eller om ni väljer eget eller öppet spel – och betalas på plats i kassan. Den gäller endast deltagandet i spelet – mat och dryck köps till separat. Genom att anmäla dig godkänner du betalning på plats.',
    bookingOptions: {
      question: 'Hur vill ni spela?',
      choices: [
        {
          label: 'Öppet spel',
          description: 'Vi kan para ihop er med andra gäster',
          note: 'Vi parar ihop er med andra gäster så att ni blir fler som löser mysteriet tillsammans.',
          partySize: {
            label: 'Hur många kommer ni?',
            min: 1,
            max: 20,
          },
        },
        {
          label: 'Eget spel för vår grupp',
          description: 'Ni spelar i ert eget sällskap – minst 4 personer',
          partySize: {
            label: 'Hur många är ni i gruppen?',
            min: 4,
            max: 20,
            hint: 'Ange exakt hur många ni är. Ni behöver vara minst 4 för att spela i egen grupp.',
            minMessage:
              'Ni behöver vara minst 4 för att spela i egen grupp – är ni färre, välj Öppet spel.',
          },
        },
      ],
    },
    signup: true,
  },
  {
    id: 'halloween-barnens-dag',
    title: 'Lilla Monster Loppet',
    date: '2026-10-29',
    time: '13.30–14.30',
    description:
      'En dag för alla små monster! Kom utklädd i din läskigaste, finaste eller galnaste halloweenkostym och spring vårt Halloweenlopp tillsammans med andra barn. I mål väntar ett efterlängtat godisregn!',
    highlight: {
      title: 'Viktigt',
      text: 'Man får inte springa loppet om man inte har klätt ut sig ;)',
    },
    signup: true,
  },
  {
    id: 'halloween-monsterdisko',
    title: 'Monsterdisko för barnen',
    date: '2026-10-30',
    time: '18.00–20.00',
    description:
      'Efter Växjö Citys Zombiewalk fortsätter festen på Top Notch! Dans, musik och massor av Halloweenstämning.',
    signup: true,
    childSignup: true,
    highlight: {
      title: '79 kr per barn · betalas på plats',
      text: 'Alla barn som ska vara med måste anmälas med för- och efternamn. Har du flera barn kan du anmäla alla i samma anmälan. Betalning sker på plats i kassan.',
    },
    formNote:
      'Pris 79 kr per barn som betalas på plats i kassan. Genom att anmäla godkänner du betalning på plats.',
    ctaLabel: 'Anmäl dig',
  },
  {
    id: 'halloween-pa-top-notch',
    title: 'Top Notch halloween',
    date: '2026-10-31',
    description:
      'Självaste Halloween! En dag fylld med spökliga överraskningar, goda smaker och härlig stämning. Kom gärna utklädd och upplev en magisk dag hos oss!',
    dropIn: true,
  },
  {
    id: 'halloween-hostbrunch',
    locked: true,
    lockedText: 'Spökiga överraskningar kanske lanseras snart…',
    title: 'Höstbrunch',
    date: '2026-11-01',
    time: 'Sittning 1 · 10.00–12.00',
    secondaryTime: 'Sittning 2 · 12.00–14.00',
    description:
      'Vi avslutar Halloweenveckan med en mysig höstbrunch. Brunchen serveras à la carte – du väljer dina rätter på plats. Njut av god mat, härlig stämning och den perfekta avslutningen på en spökligt bra vecka!',
    partySize: {
      label: 'Hur många är ni i sällskapet?',
      min: 1,
      max: 20,
      hint: 'Ange exakt hur många ni är.',
    },
    highlight: {
      title: 'Endast 2 sittningar',
      text: 'Första sittningen 10.00–12.00 och andra sittningen 12.00–14.00. Boka i tid!',
    },
    bookingOptions: {
      question: 'Vilken sittning vill du boka?',
      choices: [
        { label: 'Sittning 1', description: '10.00–12.00', time: '10.00–12.00' },
        { label: 'Sittning 2', description: '12.00–14.00', time: '12.00–14.00' },
      ],
    },
    signup: true,
    ctaLabel: 'Boka bord',
  },
]
